import { combineActions, handleActions } from 'redux-actions'
import { combineReducers } from 'redux'

import * as actions from './actions'

const lastLocation = handleActions({
  [combineActions(
    actions.fetchOnboardingStatusSuccess,
    actions.patchOnboardingStatusSuccess,
  )]: (state, action) => action.payload.lastLocation
}, null)

const isComplete = handleActions({
  [combineActions(
    actions.fetchOnboardingStatusSuccess,
    actions.patchOnboardingStatusSuccess,
  )]: (state, action) => action.payload.isComplete
}, false)

export default combineReducers({
  lastLocation,
  isComplete
})


// WEBPACK FOOTER //
// ./src/modules/state/reducer.js